import { render, staticRenderFns } from "./DSwitch.vue?vue&type=template&id=23bb4194&scoped=true&"
import script from "./DSwitch.vue?vue&type=script&lang=js&"
export * from "./DSwitch.vue?vue&type=script&lang=js&"
import style0 from "./DSwitch.vue?vue&type=style&index=0&id=23bb4194&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bb4194",
  null
  
)

export default component.exports